export default function usersReducer (state, action) {
    if (!state) {
        state = {};
    }

    switch (action.type) {
        case 'SESSION_LOGIN':
        case 'USER_DATA_RECEIVED':
            state = Object.assign({}, state);
            state[action.user.id] = action.user;
            break;
        case 'EVENT_PARTICIPANTS_LOADED':
            _(action.participants || []).each(participant => {
                if (participant.user_id) {
                    state[participant.user_id] = participant;
                }
            });
            break;
        case 'CHAT_UPDATE_ACTIVE_SESSIONS':
            state = {...state};
            _(action.activeSessions).each(chatSession => {
                let user = {
                    first_name: chatSession.name,
                    last_name: chatSession.surname,
                    image_url: chatSession.avatarUrl,
                    ...chatSession.partner,
                    id: chatSession.otherUserId,
                };
                state[chatSession.otherUserId] = {
                    ...state[chatSession.otherUserId],
                    ...user,
                };
            });
            break;
        case 'EVENT_QUESTIONS_LOADED':
            state = {...state};
            for (let question of action.questions) {
                let user = question.asker;
                state = {
                    ...state,
                    [user.id]: {
                        ...(state[user.id] || {}),
                        ...user,
                    },
                };
            }
            break;
        case 'EVENT_QUESTION_SET_ANSWERS':
            state = {...state};
            for (let answer of action.answers) {
                let user = answer.answerer;
                state = {
                    ...state,
                    [user.id]: {
                        ...(state[user.id] || {}),
                        ...user,
                    },
                };
            }
            break;
        case 'USER_CONNECTIONS':
            state = {...state};
            for (let connection of action.connections) {
                state[connection.id] = {
                    ...(state[connection.id] ?? {}),
                    ...connection,
                };
            }
            break;
    }

    return state;
}
